<template>
    <div id="detail_page">
        <div class="container pl-4" v-if="campaign != null">
            <div class="img-campaign-wrapper">
                <div class="icon-back" >
                    <img @click="clickBack()" src="@/assets/icon/ic-back@3x.png"/>
                </div>
                <campaign-picture class="camp-pic" :arrCampaignImage="campaign.pictures"></campaign-picture>
            </div>

            <h4 class="campaign-name">{{ campaign.name }}</h4>
            <p class="conditon-text" v-html="condition"></p>
            <!-- <h4 class="point-per-unit">{{ getPointText() }}</h4> -->

            <detail-and-condition
                :lbl="lbl"
                :campaign="campaign"
                ></detail-and-condition>
            <!-- <sub-campaign-dropdown
                :lbl="lbl"
                :subcampaign="subCampaign"
                v-if="isShowSubcampaign"
                @updateSelectedCampaignInfo="updateSelectedCampaignInfo($event)"
                ></sub-campaign-dropdown> -->
            <redeem
                :lbl="lbl"
                :campaign="campaign"
                :selectedId="campaignId"
                :selectedPoint="point"
                :selectedQuantity="quantity"
                @updateCampaignInfo="updateCampaignInfo($event)"
                ></redeem>
        </div>
    </div>
</template>
<script>
import CampaignPicture from "@/components/campaign/detail/Picture.vue";
import DetailAndCondition from "@/components/campaign/detail/DetailAndCondition";
// import SubCampaignDropdown from '@/components/campaign/detail/SubCampaignDropDown.vue';
import Redeem from "@/components/campaign/detail/Redeem.vue";

import Util from '@/helper/Utility.js';
/**
 * Property
 * @property {object} lbl (required) Text for component.
 * @property {number} locale (required) Current language.
 * @property {object} campaign (required) Campaign information.
 * Method
 * @method initialLayout Setup campaign information.
 * @method updateSelectedCampaignInfo Callback for subcampagin to update Campaign information.
 */
export default {
    name: "DefaultLayout",
    components: {
        CampaignPicture,
        DetailAndCondition,
        // SubCampaignDropdown,
        Redeem
    },
    props: {
        lbl: Object,
        locale: Number,
        campaign: Object,
    },
    data: function() {
        return {
            campaignId: '',
            quantity: 0,
            point: 0,
            price: 0,
            originPrice: 0,
            discount: 0,

            isShowSubcampaign: false,
            subCampaign: null,
            condition: null,

        };
    },
    created: function () {
        this.initialLayout();
        this.setTextCondition();
    },
    methods: {
        initialLayout: function () {

            if(this.campaign.subCampaignStyles2) {
                this.isShowSubcampaign = true;
                this.subCampaign = this.campaign.subCampaignStyles2.styles;

                if (this.campaign.subCampaignStyles2.styles.length > 0) {

                    var firstsubcampaign = this.campaign.subCampaignStyles2.styles[0];
                    if(firstsubcampaign.subitems[0].value != 'none') firstsubcampaign = firstsubcampaign.subitems[0];
                }

                this.updateSelectedCampaignInfo(firstsubcampaign);
            } else {
                this.updateSelectedCampaignInfo();
            }
        },
        getPointText: function () {
            var pointTypeTxt = this.campaign.pointType && this.campaign.pointType != 'use'
                            ? this.lbl.detail.get_point
                            : this.lbl.detail.use_point;

            var point = this.locale === 1033 && this.point != 1
                        ? this.lbl.detail.point + 's'
                        : this.lbl.detail.point;
            // var point =  this.lbl.detail.point;
            return pointTypeTxt + this.point + ' ' + point;
        },
        updateCampaignInfo: function (campaign) {
            this.campaign.updateCampaign(campaign);
            this.initialLayout();
        },
        updateSelectedCampaignInfo: function (selectedItem) {

            if(selectedItem) {
                this.campaignId  = selectedItem.campaignId;
                this.quantity = selectedItem.quantity - (selectedItem.itemCountSold || 0);
                this.point = selectedItem.points || selectedItem.point || 0;
                this.price = selectedItem.price;
                this.originalPrice = selectedItem.originalPrice;
                this.discount = selectedItem.discount;
            } else {
                this.campaignId = this.campaign.id;
                this.quantity = this.campaign.qty;
                this.point = this.campaign.pointPerUnit;
                this.price = this.campaign.pricePerUnit;
                this.originalPrice = this.campaign.originalPrice;
                this.discount = this.campaign.discount;
            }
        },

        clickBack: function () {
            //GA
            var path = '/booking'
            this.$router.push(path);
        },
        setTextCondition: function() {
            this.condition = Util.newLineToBr(this.campaign.condition);
        }
    }
};
</script>
<style lang="scss">
@import "@/style/base/common.scss";

#detail_page {
    padding-top: 20px;
    min-height: 100vh;
    .img-campaign-wrapper {
        @extend %display-flex;

        .icon-back {
            width: 10px;
            margin-right: 10px;
            position: absolute;
            z-index: 20;
            img {
                width: 12px;
            }
        }
    }
}

    .campaign-name {
        font-weight: bold;
        font-size: 1.3rem;
        margin-top: 15px;
    }
    .conditon-text{
        font-size: 0.9rem;
        // word-break: break-word;
    }
    .point-per-unit {
        font-weight: bold;
        font-size: 1.3rem;
        margin-top: 10px;
    }

    .camp-pic{
        -webkit-box-flex: 0;
        flex: 0 0 calc(100%);
    }
</style>
